import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g id="Icon-set/check">
      <path
        id="Vector"
        d="M2.33972 6.24442L4.93712 8.92299C6.15936 5.41201 7.17726 3.87136 9.48258 1.78013"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CheckArrowIcon = memo(ForwardRef);
export default CheckArrowIcon;
